<template>
  <div ref="watingZone" style="height:100%">
    <ag-grid :options="settings.table" @preSelectedRowData="(rowData) => selectedRow = rowData" :data="workshops" v-model="selectedRow" ref="workshopList" tabindex="101" startup @row_dbClicked="rowDbClicked"></ag-grid>
  </div>
</template>
<script>
  import _ from 'lodash'
  import $sc from '~/plugins/shortcut.collection.js'
  import { mapGetters } from 'vuex'

  export default {
    name: 'workshop-selector',
    modal: {
      size: 'md',
      stateUID: 'workshop-selector',
    },
    props: ['options'],
    data() {
      return {
        workshops: [],
        selectedRow: null,
        settings: {
          table: {
            id: this.$options.name,
            pagination: true,

            groupIncludeTotalFooter: false,
            enterToSelect: true,
            cellSelectionAggReport: false,
            doubleClickedToSelect: true,
            rowSelection: {
              mode: 'singleRow'
            },
            fitToWidth: true,
            columnDefs: [
              {
                field: 'code',
                headerName: this.$t('salary.workshop.f.code'),
                contentType: 'string',
                width: 100,
              },
              {
                field: 'name',
                headerName: this.$t('salary.workshop.f.name'),
                contentType: 'string',
                width: 100,
              },
              {
                field: 'startDate',
                headerName: this.$t('salary.workshop.f.startDate'),
                contentType: 'date',
                width: 100,
              },
              {
                field: 'endDate',
                headerName: this.$t('salary.workshop.f.endDate'),
                contentType: 'date',
                width: 100,
              },
            ],
          },
        },
        selectPeriodButton: {
          title: this.$t('select'),
          shortcut: $sc.find('enter'),
          icon: 'check',
          isPrimary: true,
          handle: (button, page, e) => {

            if (_.isEmpty(this.selectedRow))
              return this.$toast(this.$t('document.m.select-row'))

            this.rowDbClicked(this.selectedRow)
          },
        },
      }
    },
    watch: {
      options: {
        immediate: true,
        deep: true,
        handler(val) {
          this.settings = _.merge({}, this.settings, val)
        },
      },
    },
    computed: {
      ...mapGetters({
        activeWorkshops: 'workshops/getActives'
      })
    },
    mounted() {
      this.prepareWindow(this.$t('fiscal.list.title'), [this.selectPeriodButton])
      this.selectedRow = this.data
      this.workshops = this.activeWorkshops
    },
    methods: {
      rowDbClicked(val = this.selectedRow) {
        this.resolve(val)
      }
    },
  }
</script>
<style></style>
